import React from "react";
import "./Services.css";
import heartEmoji from "../../img/heartemoji.png";
import gasses from "../../img/glasses.png";
import humble from "../../img/humble.png";
import { Cards } from "../Cards/Cards";
import hv  from "./hv.pdf";
import { themeContext } from "../../Context";
import { useContext } from "react";
import { motion } from "framer-motion";

export const Services = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const transition = { duration: 4, type: "spring", repeatType: "reverse" };

  return (
    <div className="services" id="Services">
      {/* left side */}
      <div className="awesome">
        <span style={{ color: darkMode ? "white" : "" }}>My</span>
        <span>Services</span>
        <span style={{ color: darkMode ? "white" : "" }}>
          Develop and maintain server-side applications
          <br />
          Write and maintain APIs
          <br />
          Develop and maintain user interfaces Implement
          <br />
          Write and maintain code in HTML, CSS, and JavaScript
          <br />
          Use frontend frameworks such as React
        </span>
        <a href={hv} download>
          <button className="button s-button">Download CV</button>
        </a>
        <div className="blur s-blur1" style={{ background: "#CDF9FF99" }}></div>
      </div>
      {/* right side */}
      <div className="cards">
        <motion.div
          initial={{ top: "0", left: "18rem" }}
          whileInView={{ top: "0", left: "19rem" }}
          transition={transition}
          style={{
            top: "3rem",
            left: "18rem",
          }}
        >
          <Cards
            emoji={heartEmoji}
            heading={"Frontend"}
            detail={"HTML, CSS, JavaScript, React"}
          />
        </motion.div>
        <motion.div
          initial={{ top: "9rem", left: "3.5rem" }}
          whileInView={{ top: "8.5rem", left: "3rem" }}
          transition={transition}
          style={{ left: "3.5rem", top: "9rem" }}
        >
          <Cards
            emoji={gasses}
            heading={"Backend"}
            detail={"Java, Node.js, PHP, Spring, Express, Laravel, Python"}
          />
        </motion.div>
        <motion.div
          initial={{ top: "16rem", left: "16.5rem" }}
          whileInView={{ top: "15.8rem", left: "16rem" }}
          transition={transition}
          style={{ top: "16rem", left: "16.5rem" }}
        >
          <Cards
            emoji={humble}
            heading={"SQL"}
            detail={
              "Developer with skills in SQL and BigQuery, Pandas and data analysis"
            }
          />
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "rgb(250 240 255)" }}
        ></div>
      </div>
    </div>
  );
};
